















import { ImageMixin } from '@/utils/mixins/image'
import mixins from 'vue-typed-mixins'

export default mixins(ImageMixin).extend({
  props: {
    size: String,
    value: [String, Object],
  },
  computed: {
    src(): string {
      if (this.value) {
        if (typeof this.value === 'string') {
          return this.value
        } else {
          try {
            return URL.createObjectURL(this.value)
          } catch {
            return ''
          }
        }
      } else return ''
    },
  },
})
